import { render, staticRenderFns } from "./VantaBackground.vue?vue&type=template&id=53e5a3d6"
import script from "./VantaBackground.vue?vue&type=script&lang=js"
export * from "./VantaBackground.vue?vue&type=script&lang=js"
import style0 from "./VantaBackground.vue?vue&type=style&index=0&id=53e5a3d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports